import Vue from "vue";
import "@babel/polyfill";
import "es6-promise/auto";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { mapState } from "vuex";
import common from "./utils/commonUtils";

Vue.config.productionTip = false;
Vue.use(common);

new Vue({
  router,
  store,
  mapState: mapState,
  render: h => h(App),
}).$mount("#app");
